import { ServiceCall } from "support/network/ServiceCallAction"
import { prepareHeadersFromState } from "../../HeadersUtils"


import { ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE, ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED, ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS, ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE, ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED, ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS, ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE, DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED, DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS, DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE, DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED, DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS, DELETE_INNOVATE_IDEA_BY_ID_FAILURE, DELETE_INNOVATE_IDEA_BY_ID_STARTED, DELETE_INNOVATE_IDEA_BY_ID_SUCCESS, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED, GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS, GET_IDEA_ID_DETAILS_INNOVATE_FAILURE, GET_IDEA_ID_DETAILS_INNOVATE_STARTED, GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED, GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED, GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS, GET_INNOVATE_IDEA_TEAM_FAILURE, GET_INNOVATE_IDEA_TEAM_STARTED, GET_INNOVATE_IDEA_TEAM_SUCCESS, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED, GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS, GET_INNOVATE_ALL_IDEA_LIST_FAILURE, GET_INNOVATE_ALL_IDEA_LIST_STARTED, GET_INNOVATE_ALL_IDEA_LIST_SUCCESS, GET_INNOVATE_MY_IDEA_FAILURE, GET_INNOVATE_MY_IDEA_STARTED, GET_INNOVATE_MY_IDEA_SUCCESS, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED, GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS, GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE, GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED, GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED, GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED, GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED, GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED, GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS, GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE, GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED, GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED, GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS, INNOVATE_DELETE_USER_FROM_TEAM_FAILURE, INNOVATE_DELETE_USER_FROM_TEAM_STARTED, INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS, POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE, POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED, POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS, POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE, POST_INNOVATE_CREATE_IDEA_EDIT_STARTED, POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS, POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE, POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED, POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS, POST_INNOVATE_IDEA_APPROVE_FAILURE, POST_INNOVATE_IDEA_APPROVE_STARTED, POST_INNOVATE_IDEA_APPROVE_SUCCESS, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED, POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED, PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS, PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_FAILURE, PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_STARTED, PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_SUCCESS, PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_FAILURE, PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_STARTED, PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_SUCCESS, GET_IDEA_HISTORY_INNOVATE_STARTED, GET_IDEA_HISTORY_INNOVATE_SUCCESS, GET_IDEA_HISTORY_INNOVATE_FAILURE, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS, ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS, INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE, INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED, INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS, INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE } from "actions/sync/innovate/idea/Constants"
import { MOVE_TO_DRAFT_INNOVATE_STARTED, MOVE_TO_DRAFT_INNOVATE_SUCCESS, MOVE_TO_DRAFT_INNOVATE_FAILURE,GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED,GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS,GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE } from "actions/sync/innovate/idea/Constants"
// import { setDocumentBody } from "services/create_idea/RequestUtils"
import { transformDeleteDocument, transformDocumentUploadResponse, transformGetIdeaResponse, transformImageServiceResponseWithState } from "services/create_idea/ResponseUtils"
import * as userProfileActions from 'actions/sync/user_profile/Constants'
import { setIdeaBodyFromState } from "./RequestUtils"
import { safeJSONStringify } from "../templates/index"
import { LOAD_MORE_SIZE } from "common_constants/Ideas"

const GET_USER_IDEAS_URL = '/api/v1/user/##email##/idea'
// const DELETE_USER_FROM_TEAM_URL = '/s/idea/##id##/team/##email##?initiative=##isInitiative##'
const DELETE_USER_FROM_TEAM_URL = '/api/v1/innovate/idea/deleteIdeaTeamMembar'
// const GET_VALIDATE_SCORECARD_USER_URL = '/api/v1/innovate/evaluator/scorecard/show/##ideaIdKey##/##userEmail##'
const GET_VALIDATE_SCORECARD_USER_URL = '/api/v1/innovate/evaluator/scorecard/show/##ideaIdKey##/##userEmail##/##businessSCFlag##'
// only used show popup scorecard api data
const GET_POPUP_SCORECARD_USER_URL = '/api/v1/innovate/evaluator/scorecard/popup/##ideaIdKey##/##userEmail##/##businessSCFlag##'
const POST_FROM_EVALUATOR_RATING_SAVE_URL = '/api/v1/innovate/evaluator/rating/save'
const PUT_FROM_EVALUATOR_RATING_EDIT_URL = '/api/v1/innovate/evaluator/rating/edit'
const PUT_FROM_EVALUATOR_RATING_SUBMIT_URL = '/api/v1/innovate/evaluator/rating/submit'

// const GET_JSON_EVALUATOR_RATED_URL = '/api/v1/innovate/evaluator/scorecard/popup/##ideaIdKey##/##userEmail##'
const GET_JSON_EVALUATOR_RATED_URL = '/api/v1/innovate/evaluator/scorecard/popup/##ideaIdKey##/##userEmail##/##businessSCFlag##'
const DELETE_USER_EVALUATOR_URL = '/api/v1/innovate/evaluator/idearating/delete/##ideaIdKey##/##userEmail##/##businessSCFlag##'
const DELETE_ALLUSER_EVALUATOR_URL = '/api/v1/innovate/evaluator/scorecard/popup/all/##ideaIdKey##/##userEmailCommaSeparated##/##scoreCardFlag##'
const ADD_USER_EVALUATOR_URL = '/api/v1/innovate/evaluator/assign/evaluator'
const ADD_USER_COMMNUNITY_EVALUATOR_URL = '/api/v1/innovate/evaluator/assign/community/evaluator'
const GET_SEARCH_BY_COMMNUNITY_EVALUATOR_URL = '"/api/v1/group/expert/community/##search-by-community##'

const GET_JSON_TEMPLATE_ID_URL = '/api/v1/innovate/template/scorecard/##ChalengeTemplateId##'
// show list Evaluator Question only 
const GET_LIST_EVALUATOR_ASSIGN_IDEA_ID_URL = '/api/v1/innovate/evaluator/idearating/##ideaIdKey##'

const SEARCH_BY_EMAIL = '/s/user/search-by-email'
const GET_IDEA_URL = '/s/idea/'
const ADD_IMAGE_URL = '/s/idea/image'
const DELETE_IDEA_BY_ID_URL = '/s/idea/##id##'
const DELETE_IDEA_IMAGE_URL = '/s/gcs/##image_key##/##id##'
const GET_ID_DRAFT_URL = 'api/v1/innovate/idea/initial/draft'
const GET_INNOVATE_IDEA_URL = 'api/v1/innovate/idea/innovateidea'
const GET_INNOVATE_IDEA_EMAIL_URL = 'api/v1/innovate/idea/innovateidea/##userEmail##'
const POST_INNOVATE_IDEA_APPROVE_URL = 'api/v1/innovate/idea/innovateidea/approve'
const getIdeaTemplateJsonBasedOnIdURL = 'api/v1/innovate/idea/ideatemplate'
const GET_Innovate_IdeaList_URL = 'api/v1/innovate/idea/ideaList'
const draftInnovateCreateIdeaURL = 'api/v1/innovate/idea/draftIdea'
const submitInnovateCreateIdeaURL = 'api/v1/innovate/idea/publishIdea'
const editInnovateCreateIdeaURL = 'api/v1/innovate/idea/editIdea'
const POST_IDEA_DOCUMENT_URL = '/s/idea/##inIdeaK##/##inDocIdeaK##/document'
const DELETE_IDEA_DOCUMENT_URL = '/api/v1/idea/##id##/document/##documentId##'
const INNOVATE_ME_IDEA_URL = '/api/v1/innovate/idea/me'
const GET_IDEA_INNOVATE_TEAM_URL = '/s/idea/##id##/team'
const POST_INNOVATE_IDEA_ADD_TEAM_URL = '/api/v1/innovate/idea/addInnovateIdeaTeamMembar'
const POST_INNOVATE_IDEA_INVITE_TEAM_URL = '/api/v1/innovate/idea/inviteIdeaTeamMembar'
const addBusinessScoreCardURL = 'api/v1/innovate/idea/addBusinessScoreCard'
const GET_IDEA_HISTORY_URL = '/api/v1/innovate/idea/history/##ideaId##'
const MOVE_TO_DRAFT_URL = '/api/v1/innovate/idea/moveToDraft/##ideaId##'
const ADD_BULK_SME_AUTO_ASSIGN_EVALUATOR_URL = '/api/v1/innovate/evaluator/sme/evaluator/autoAssignSme'
const Innovate_CHALLENGE_TAGGED_IDEA_LIST_URL = '/api/v1/innovate/evaluator/sme/getchallenge/ideasEvaluator/##challengeKey##'
export const GET_INNOVATE_IDEA_HISTORY_EMAIL_URL='/api/v1/innovate/idea/innovateidea/history/##email##'

const setContentForAddBusinessScoreCard = (addBusinessScoreCardParams) => {
  // console.log("🚀 ~ setContentForIdeaApprove ~ ideaApporveParams:", ideaApporveParams)
  const {ideaIdKey,businessScoreCardTemplateId,businessSCQuestionJson} = addBusinessScoreCardParams || {}
  const ConvertJsonObjToStr = safeJSONStringify(businessSCQuestionJson)
  return `${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('businessScoreCardTemplateId')}=${encodeURIComponent(businessScoreCardTemplateId)}&${encodeURIComponent('businessSCQuestionJson')}=${encodeURIComponent(ConvertJsonObjToStr)}`
}



 const setContent = (ideaId, image) => {
  let url = ''
  if (ideaId) {
    url = `${encodeURIComponent('ideaId')}=${encodeURIComponent(ideaId)}&`
  }
  return `${url}${encodeURIComponent('image')}=${encodeURIComponent(image?.src)}&${encodeURIComponent(
    'upload_type',
  )}=${encodeURIComponent('IMAGE_UPLOAD')}`
}

 const setContentForIdeaApprove = (ideaApporveParams) => {
  const {ideaIdKey,status,comment} = ideaApporveParams || {}
  return `${encodeURIComponent('ideaIdKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('ideaStatus')}=${encodeURIComponent(status)}&${encodeURIComponent('approveComment')}=${encodeURIComponent(comment)}`
}


function setContentAddBulkSME(AddBulkEvaluatParams) {
  console.log("AddBulkEvaluatParams params :", AddBulkEvaluatParams)
    const {
      challengeKey=null,
      businessSCFlag='',
      groupName='',
      groupId='',
    } = AddBulkEvaluatParams || {}
  return `${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('businessSCFlag')}=${encodeURIComponent(businessSCFlag)}&${encodeURIComponent('groupName')}=${encodeURIComponent(groupName)}&${encodeURIComponent('groupId')}=${encodeURIComponent(groupId)}`
}


function setContentRatingEditEvaluator(RatingEditEvaluatorParams) {
  const {
    evaluationRatingId=null,
    ideaIdKey=null,
    challengeKey=null,
    scoreCardJson='',
    scoreCardAnswerJson='',
    userEmail=null,
    scoreCardRating=''
  } = RatingEditEvaluatorParams || {}
return `${encodeURIComponent('evaluationRatingId')}=${encodeURIComponent(evaluationRatingId)}&${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(scoreCardJson)}&${encodeURIComponent('scoreCardAnswerJson')}=${encodeURIComponent(scoreCardAnswerJson)}&${encodeURIComponent('userEmail')}=${encodeURIComponent(userEmail)}&${encodeURIComponent('scoreCardRating')}=${encodeURIComponent(scoreCardRating)}`
}

function setContentRatingSaveEvaluator(RatingSaveEvaluatorParams) {
  console.log("RatingSaveEvaluatorParams===> :  ", RatingSaveEvaluatorParams)
  const {
    ideaEvaluationId=null,
    ideaIdKey=null,
    challengeKey=null,
    scoreCardJson='',
    scoreCardAnswerJson='',
    userEmail=null,
    scoreCardRating='',
    businessSCFlag = ''
  } = RatingSaveEvaluatorParams || {}

  const ConvertJsonObjToStr = safeJSONStringify(scoreCardJson)
  const ConvertJsonObjToStrAns = safeJSONStringify(scoreCardAnswerJson)

return `${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(ConvertJsonObjToStr)}&${encodeURIComponent('scoreCardAnswerJson')}=${encodeURIComponent(ConvertJsonObjToStrAns)}&${encodeURIComponent('userEmail')}=${encodeURIComponent(userEmail)}&${encodeURIComponent('scoreCardRating')}=${encodeURIComponent(scoreCardRating)}&${encodeURIComponent('ideaEvaluationId')}=${encodeURIComponent(ideaEvaluationId)}&${encodeURIComponent('businessSCFlag')}=${encodeURIComponent(businessSCFlag)}`
}


function setContentAddEvaluator(AddEvaluatorParams) {
  console.log("search by community or single user params :", AddEvaluatorParams)
    const {
      ideaEvaluationId = 0,
      ideaIdKey=null,
      challengeKey=null,
      scoreCardJson='',
      scoreCardAnswerJson='',
      userEmail=null,
      scoreCardRating='',
      businessSCFlag='',
      selectedScoreCardTemplateId= 0 ,
      groupName='',
      groupId='',
    } = AddEvaluatorParams || {}
    const selectedScoreCardTemplateIdNumber = Number(selectedScoreCardTemplateId)
    console.log("selectedScoreCardTemplateIdNumber", selectedScoreCardTemplateIdNumber)
  return `${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('ideaEvaluationId')}=${encodeURIComponent(ideaEvaluationId)}&${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(scoreCardJson)}&${encodeURIComponent('scoreCardAnswerJson')}=${encodeURIComponent(scoreCardAnswerJson)}&${encodeURIComponent('userEmail')}=${encodeURIComponent(userEmail)}&${encodeURIComponent('scoreCardRating')}=${encodeURIComponent(scoreCardRating)}&${encodeURIComponent('businessSCFlag')}=${encodeURIComponent(businessSCFlag)}&${encodeURIComponent('selectedScoreCardTemplateId')}=${encodeURIComponent(selectedScoreCardTemplateIdNumber)}&${encodeURIComponent('groupName')}=${encodeURIComponent(groupName)}&${encodeURIComponent('groupId')}=${encodeURIComponent(groupId)}`
}

function setContentAddTeamMember(AddTeamsParams) {
    const {
      ideaIdKey=null,
      userEmail=null,
    } = AddTeamsParams || {}
  return `${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaIdKey)}&${encodeURIComponent('userEmailsCommaSeparated')}=${encodeURIComponent(userEmail)}`
}
function setContentDeleteTeamMember(ideaId,email) {
  return `${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaId)}&${encodeURIComponent('userEmail')}=${encodeURIComponent(email)}`
}

function setDocumentBody(id,fileName, documentsKey,base64File) {
  return `${encodeURIComponent('inIdeaK')}=${encodeURIComponent(id)}&${encodeURIComponent('inDocIdeaK')}=${encodeURIComponent(documentsKey)}&${encodeURIComponent('fileName')}=${encodeURIComponent(fileName)}&${encodeURIComponent(
    'file',
  )}=${encodeURIComponent(base64File)}`
}

function setInnovateCreateIdeaDraftEndpoint(draftCreateIdeaData) {
 
 const {
  challengeKey,
  ideaKey,
  businessUnit='',
  market,
  additionalInfo='',
  addInfo='',
  title='',
  summary='',
  coverPhoto=[],
  documentsKey,
  ideaTemplate=null,
  ideaTemplateAnswers,tncIdea=false,isIdeaTermAccepted=false

 } = draftCreateIdeaData


 const converJSONIdeaTemplate = safeJSONStringify(ideaTemplate)
const convertJSONideaTemplateAnswers = safeJSONStringify(ideaTemplateAnswers)
 const alldocumentkeyArrList = documentsKey ? documentsKey.map(document => document.key) : null
 const allimgArrList = coverPhoto
//  Array.isArray(coverPhoto)   ? coverPhoto?.map(img => img?.name) : coverPhoto
  // return `${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaKey)}&${encodeURIComponent('isIdeaTermAccepted')}=${encodeURIComponent(tncIdea)}&${encodeURIComponent('businessUnit')}=${encodeURIComponent(businessUnit)}&${encodeURIComponent('title')}=${encodeURIComponent(title)}&${encodeURIComponent('description')}=${encodeURIComponent(summary)}&${encodeURIComponent('documentsKey')}=${encodeURIComponent(alldocumentkeyArrList)}&${encodeURIComponent('images')}=${encodeURIComponent(allimgArrList)}&${encodeURIComponent('additionalInfo')}=${encodeURIComponent(addInfo || additionalInfo)}&${encodeURIComponent('ideaTemplate')}=${encodeURIComponent(converJSONIdeaTemplate)}&${encodeURIComponent('ideaTemplateAnswers')}=${encodeURIComponent(convertJSONideaTemplateAnswers)}`;
  return `${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('ideaKey')}=${encodeURIComponent(ideaKey)}&${encodeURIComponent('market')}=${encodeURIComponent(market)}&${encodeURIComponent('isIdeaTermAccepted')}=${encodeURIComponent(isIdeaTermAccepted || tncIdea)}&${encodeURIComponent('businessUnit')}=${encodeURIComponent(businessUnit)}&${encodeURIComponent('title')}=${encodeURIComponent(title)}&${encodeURIComponent('description')}=${encodeURIComponent(summary)}&${encodeURIComponent('documentsKey')}=${encodeURIComponent(alldocumentkeyArrList)}&${encodeURIComponent('images')}=${encodeURIComponent(allimgArrList)}&${encodeURIComponent('additionalInfo')}=${encodeURIComponent(addInfo || additionalInfo)}&${encodeURIComponent('ideaTemplate')}=${encodeURIComponent(converJSONIdeaTemplate)}&${encodeURIComponent('ideaTemplateAnswers')}=${encodeURIComponent(convertJSONideaTemplateAnswers)}`;

}


export function postInnovateIdeaApprove(approveIdeaData,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_IDEA_APPROVE_STARTED
  apiCall.successReqType = POST_INNOVATE_IDEA_APPROVE_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_IDEA_APPROVE_FAILURE
  apiCall.setEndpointFromState = () => POST_INNOVATE_IDEA_APPROVE_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setContentForIdeaApprove(approveIdeaData)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

//create Draft idea
export function postInnovateCreateIdeaDraft(draftCreateIdeaData,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED
  apiCall.successReqType = POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE
  apiCall.setEndpointFromState = () => draftInnovateCreateIdeaURL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setInnovateCreateIdeaDraftEndpoint(draftCreateIdeaData)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}


//create Publish idea
export function postInnovateCreateIdeaPublish(CreateIdeaData,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED
  apiCall.successReqType = POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE
  apiCall.setEndpointFromState = () => submitInnovateCreateIdeaURL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState= ()=> setIdeaBodyFromState(CreateIdeaData)
  // apiCall.setBodyFromState= ()=> setInnovateCreateIdeaDraftEndpoint(CreateIdeaData)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}


//create Edit/update idea
export function postInnovateCreateIdeaEdit(editIdeaData,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_CREATE_IDEA_EDIT_STARTED
  apiCall.successReqType = POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE
  apiCall.setEndpointFromState = () => editInnovateCreateIdeaURL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState= ()=> setInnovateCreateIdeaDraftEndpoint(editIdeaData)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

// assign business scorecard

export function putAddBusinessScoreCard(addBusinessScoreCardParams,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED
  apiCall.successReqType = PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS
  apiCall.failureReqType = PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE
  apiCall.setEndpointFromState = () => addBusinessScoreCardURL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState= ()=> setContentForAddBusinessScoreCard(addBusinessScoreCardParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}


//get id at 1st time when create new idea in innovate from ideatemplateDtO table
export function getInnovateIdeaTemplateIdJson(idIdeaTemplate, onFailure) {
  const geturl = `${getIdeaTemplateJsonBasedOnIdURL}/${idIdeaTemplate}`
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED
  apiCall.successReqType = GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE
  apiCall.setEndpointFromState = () => geturl
  apiCall.method = 'GET'
  apiCall.auth = true
  apiCall.onFailure = onFailure
  return apiCall.getAction()
}


//get draft idea id on intial load and pass draftapi ideakey
export const getInitialInnovateIdeaDraft = () => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED
  apiCall.successReqType = GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS
  apiCall.failureReqType = GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE
  apiCall.setEndpointFromState = () => GET_ID_DRAFT_URL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

// post documents idea innovate

export function postInnovateIdeaDocument(id,fileName, documentsKey,base64File, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_STARTED'
  apiCall.successReqType = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_SUCCESS'
  apiCall.failureReqType = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_FAILURE'
  apiCall.setEndpointFromState = () => `${POST_IDEA_DOCUMENT_URL.replace('##inIdeaK##', id).replace('##inDocIdeaK##',documentsKey)}`
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setDocumentBody(id,fileName, documentsKey,base64File)
  apiCall.transformResponseDataWithState = transformDocumentUploadResponse
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
} 

//delete coduments
export function deleteInnovateIdeaDocument(ideaId, documentId, onFailure) {
  // console.log("==============================> Document Key", ideaId , documentId)
  const apiCall = new ServiceCall()
  apiCall.startedReqType = 'DELETE_INNOVATE_IDEA_DOCUMENT_STARTED'
  apiCall.successReqType = 'DELETE_INNOVATE_IDEA_DOCUMENT_SUCCESS'
  apiCall.failureReqType = 'DELETE_INNOVATE_IDEA_DOCUMENT_FAILURE'
  apiCall.setEndpointFromState = () =>
    `${DELETE_IDEA_DOCUMENT_URL.replace('##id##', ideaId).replace('##documentId##', documentId)}`
  apiCall.method = 'DELETE'
  apiCall.auth = true
  apiCall.onFailure = onFailure
  // apiCall.transformResponseDataWithState = (_, state) => transformDeleteDocument(documentId, state.data.InnovateIdea.getInnovateIdeaDocumentUpload)
  apiCall.transformResponseDataWithState = (_, state) =>
  state.data.InnovateIdea.getInnovateIdeaDocumentUpload.filter(
    doc => doc.key !== documentId
  )
  return apiCall.getAction()
}



export function postInnovateIdeaImage(ideaId, image, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED
  apiCall.successReqType = ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS
  apiCall.failureReqType = ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => ADD_IMAGE_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContent(ideaId, image)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.transformResponseDataWithState = transformImageServiceResponseWithState
  apiCall.auth = true
  return apiCall.getAction()
}

export function deleteInnovateIdeaImage(ideaId, imageKey, onFailure) {
  console.log("Delete ideaId:", ideaId)
  console.log("Delete image:", imageKey)
  const {key:imageUploadedKey} = imageKey || {}
  const apiCall = new ServiceCall()
  apiCall.startedReqType = DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED
  apiCall.successReqType = DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS
  apiCall.failureReqType = DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () =>
    DELETE_IDEA_IMAGE_URL.replace('##id##', ideaId).replace(
      '##image_key##',
      encodeURIComponent(imageUploadedKey),
    )
  apiCall.method = 'DELETE'
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}


//get idea 
export const getIdeaInnovateDetail = id => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_IDEA_ID_DETAILS_INNOVATE_STARTED
  apiCall.successReqType = GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_IDEA_ID_DETAILS_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => `${GET_IDEA_URL}${id}`
  apiCall.method = 'GET'
  apiCall.auth = true
  apiCall.transformResponseDataWithState = transformGetIdeaResponse
  return apiCall.getAction()
}

//get get User Evaluator list 
export const getUserEvaluatorSuggestions = (username) => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED
  apiCall.successReqType = GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () =>`${SEARCH_BY_EMAIL}?${encodeURIComponent('e')}=${encodeURIComponent(username)}&f=ALL`
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformSuggestions
  return apiCall.getAction()
}

//get  Seacrh by Community User Evaluator list 
export const getSearchByCommunutyUserEvaluatorSuggestions = (getCommunityName) => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED
  apiCall.successReqType = GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () =>GET_SEARCH_BY_COMMNUNITY_EVALUATOR_URL.replace('##search-by-community##', getCommunityName)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformSuggestions
  return apiCall.getAction()
}


// current ide delete
export function deleteInnovateIdeaById(id) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = DELETE_INNOVATE_IDEA_BY_ID_STARTED
  apiCall.successReqType = DELETE_INNOVATE_IDEA_BY_ID_SUCCESS
  apiCall.failureReqType = DELETE_INNOVATE_IDEA_BY_ID_FAILURE
  apiCall.setEndpointFromState = () => DELETE_IDEA_BY_ID_URL.replace('##id##', id)
  apiCall.method = 'DELETE'
  apiCall.auth = true
  return apiCall.getAction()
}


//get get scorecard json based on challengeTemplateId 
export const getScorecardJsonBasedOnChallengeTemplateId = (chalengeTemplateId) => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED
  apiCall.successReqType = GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_JSON_TEMPLATE_ID_URL.replace('##ChalengeTemplateId##', chalengeTemplateId)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformSuggestions
  return apiCall.getAction()
}


// evaluator popup json access for the idea
export const getJsonRatedEvaluatorScorecard = (evaluatorJsonParams) => {
  const {ideaIdKey,userEmail,businessSCFlag} = evaluatorJsonParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED
  apiCall.successReqType = GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_JSON_EVALUATOR_RATED_URL.replace('##ideaIdKey##',ideaIdKey).replace('##userEmail##',userEmail).replace('##businessSCFlag##',businessSCFlag)
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

// scorecard user validate url 
export const getUserValidateEvaluatorScorecardRole = (evaluatorCheckRoleParams) => {
  // console.log("evaluatorCheckRoleParams===> validate==>", evaluatorCheckRoleParams)
  const {ideaIdKey,userEmail,businessSCFlag = "E"} = evaluatorCheckRoleParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED
  apiCall.successReqType = GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_VALIDATE_SCORECARD_USER_URL.replace('##ideaIdKey##',ideaIdKey).replace('##userEmail##',userEmail).replace('##businessSCFlag##',businessSCFlag)
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}


//list evaluator assigned for the idea
export const getListEvaluatorAssignedForIdea = (ideaIdKey) => {
  console.log("GEt idea key getListEvaluatorAssignedForIdea ==>", ideaIdKey)
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED
  apiCall.successReqType = GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_LIST_EVALUATOR_ASSIGN_IDEA_ID_URL.replace('##ideaIdKey##', ideaIdKey)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformSuggestions
  return apiCall.getAction()
}



//show popup when click button  evaluator  the idea
export const getShowPopupForEvaluatorScorecardAssignedIdea = (evaluatorCheckRoleAndShowParams) => {
  console.log(" GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS show popup when click ==>", evaluatorCheckRoleAndShowParams)
  const {ideaId,userEmail,businessSCFlag = "E"} = evaluatorCheckRoleAndShowParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED
  apiCall.successReqType = GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_POPUP_SCORECARD_USER_URL.replace('##ideaIdKey##',ideaId).replace('##userEmail##',userEmail).replace('##businessSCFlag##',businessSCFlag)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformSuggestions
  return apiCall.getAction()
}

// Delete Evaluator
export function deleteAssignedEvaluatorIntoIdeaDetail(deleteEvaluatorlistParams, onSuccess, onFailure) {
  const {ideaIdKey,userEmail,businessSCFlag = "E"} = deleteEvaluatorlistParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED
  apiCall.successReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS
  apiCall.failureReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE
  apiCall.setEndpointFromState = () =>`${DELETE_USER_EVALUATOR_URL.replace('##ideaIdKey##',ideaIdKey).replace('##userEmail##',userEmail).replace('##businessSCFlag##',businessSCFlag)}`
  apiCall.method = 'DELETE'
  apiCall.auth = true
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  return apiCall.getAction()
}



// Delete Evaluator bulk 
export function deleteAllAssignedEvaluatorIntoIdea(deleteEvaluatorlistParams, onSuccess, onFailure) {
  const {ideaIdKey,userEmail,businessSCFlag = "E"} = deleteEvaluatorlistParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED
  apiCall.successReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS
  apiCall.failureReqType = DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE
  apiCall.setEndpointFromState = () =>`${DELETE_ALLUSER_EVALUATOR_URL.replace('##ideaIdKey##',ideaIdKey).replace('##userEmailCommaSeparated##',userEmail).replace('##scoreCardFlag##',businessSCFlag)}`
  apiCall.method = 'DELETE'
  apiCall.auth = true
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  return apiCall.getAction()
}





// add evaluator 
export function postInnovateIdeaAddEvaluator(AddEvaluatorParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => ADD_USER_EVALUATOR_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContentAddEvaluator(AddEvaluatorParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

// add after seach user Community evaluator 
export function postInnovateIdeaAddSearchByCommunityEvaluator(AddCommunityEvaluatorParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => ADD_USER_COMMNUNITY_EVALUATOR_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContentAddEvaluator(AddCommunityEvaluatorParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

//save evaluator json form
export function postInnovateIdeaEvaluatorRatingSave(RatingSaveEvaluatorParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => POST_FROM_EVALUATOR_RATING_SAVE_URL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState = () => setContentRatingSaveEvaluator(RatingSaveEvaluatorParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}
export function putInnovateIdeaEvaluatorRatingEdit(RatingEditEvaluatorParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => PUT_FROM_EVALUATOR_RATING_EDIT_URL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState = () => setContentRatingEditEvaluator(RatingEditEvaluatorParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}
export function putInnovateIdeaEvaluatorRatingSubmit(RatingSubmitEvaluatorParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => PUT_FROM_EVALUATOR_RATING_SUBMIT_URL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState = () => setContentRatingEditEvaluator(RatingSubmitEvaluatorParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}




//get evalution dash board innovate idea
export const getEvaluationDashboadInnovateIdea= () => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED
  apiCall.successReqType = GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => GET_INNOVATE_IDEA_URL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

//get evalution dash board innovate idea email
export const getEvaluationDashboadInnovateMyIdea= (userEmail) => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED
  apiCall.successReqType = GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE
  // apiCall.setEndpointFromState = () => `${GET_INNOVATE_IDEA_EMAIL_URL}?${encodeURIComponent('userEmail')}=${encodeURIComponent(userEmail)}`
  apiCall.setEndpointFromState = () => GET_INNOVATE_IDEA_EMAIL_URL.replace('##userEmail##',userEmail)
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

//get idea home when is hackthon true
export const getInnovateIdeaIfHackthonTrue= (ideaParams) => {
  const {offset = 0 , enableIsHackathon = true, limit = LOAD_MORE_SIZE} = ideaParams
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED
  apiCall.successReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () =>`${GET_Innovate_IdeaList_URL}?offset=${offset}&isHackathon=${enableIsHackathon}&limit=${limit}`
  // apiCall.setEndpointFromState = () => GET_Innovate_IdeaList_URL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

/**
 * Query string for ideaList (All Ideas). `statuses` are backend status keys ("Evaluating",
 * "Selected_For_Hackathon", ...), sent as repeated `status` params because the endpoint takes
 * `List<String> status`.
 */
const buildInnovateIdeaListQuery =({ offset = 0, limit = LOAD_MORE_SIZE, statuses = [] }) => {
  const params = new URLSearchParams()
  params.append('offset', String(offset))
  params.append('limit', String(limit))
  params.append('isHackathon', 'true')
  statuses.forEach(status => params.append('status', status))
  return params.toString()
}

// All Ideas page: filtered / paged ideaList. The page keeps the result in its own state (onSuccess).
// The unfiltered first page is the same list Explore and the footer count read from
// `ifHackthonTrueGetInnovateIdea`, so only that request uses the shared action types; filtered
// results and further pages never overwrite the shared slice.
export const getInnovateAllIdeaList = ({ onSuccess, onFailure, ...query }) => {
  const { offset = 0, statuses = [] } = query
  const isUnfilteredFirstPage = offset === 0 && statuses.length === 0
  const apiCall = new ServiceCall()
  if (isUnfilteredFirstPage) {
    apiCall.startedReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED
    apiCall.successReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS
    apiCall.failureReqType = GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE
  } else {
    apiCall.startedReqType = GET_INNOVATE_ALL_IDEA_LIST_STARTED
    apiCall.successReqType = GET_INNOVATE_ALL_IDEA_LIST_SUCCESS
    apiCall.failureReqType = GET_INNOVATE_ALL_IDEA_LIST_FAILURE
  }
  apiCall.setEndpointFromState = () => `${GET_Innovate_IdeaList_URL}?${buildInnovateIdeaListQuery(query)}`
  apiCall.method = 'GET'
  apiCall.auth = true
  if (onSuccess) apiCall.onSuccess = onSuccess
  if (onFailure) apiCall.onFailure = onFailure
  return apiCall.getAction()
}


export const getInnovateMyIdea= () => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_MY_IDEA_STARTED
  apiCall.successReqType = GET_INNOVATE_MY_IDEA_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_MY_IDEA_FAILURE
  
  apiCall.setEndpointFromState = () => INNOVATE_ME_IDEA_URL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}


// Get Team Member of idea
export function getInnovateIdeaTeam(ideaId) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_IDEA_TEAM_STARTED
  apiCall.successReqType = GET_INNOVATE_IDEA_TEAM_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_IDEA_TEAM_FAILURE
  apiCall.setEndpointFromState = () => GET_IDEA_INNOVATE_TEAM_URL.replace('##id##', ideaId)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformIdeaTeamResponse
  return apiCall.getAction()
}

// add team Member idea
export function postAddInnovateIdeaTeamMembar(AddTeamsParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED
  apiCall.successReqType = ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => POST_INNOVATE_IDEA_ADD_TEAM_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContentAddTeamMember(AddTeamsParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}
// invite team Member idea
export function postInviteInnovateIdeaTeamMembar(AddTeamsParams, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED
  apiCall.successReqType = INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => POST_INNOVATE_IDEA_INVITE_TEAM_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContentAddTeamMember(AddTeamsParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}


export function deleteInnovateUserFromTeam(ideaId, email, isInitiative = false, onSuccess, onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = INNOVATE_DELETE_USER_FROM_TEAM_STARTED
  apiCall.successReqType = INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS
  apiCall.failureReqType = INNOVATE_DELETE_USER_FROM_TEAM_FAILURE
  apiCall.setEndpointFromState = () => DELETE_USER_FROM_TEAM_URL
  apiCall.setBodyFromState = () => setContentDeleteTeamMember(ideaId,email)
  apiCall.method = 'DELETE'
  apiCall.auth = true
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  return apiCall.getAction()
}


// Get Idea History
export function getIdeaHistory(ideaId) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_IDEA_HISTORY_INNOVATE_STARTED
  apiCall.successReqType = GET_IDEA_HISTORY_INNOVATE_SUCCESS
  apiCall.failureReqType = GET_IDEA_HISTORY_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => GET_IDEA_HISTORY_URL.replace('##ideaId##', ideaId)
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

// Move Idea to Draft
export function moveToDraft(ideaId,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = MOVE_TO_DRAFT_INNOVATE_STARTED
  apiCall.successReqType = MOVE_TO_DRAFT_INNOVATE_SUCCESS
  apiCall.failureReqType = MOVE_TO_DRAFT_INNOVATE_FAILURE
  apiCall.setEndpointFromState = () => MOVE_TO_DRAFT_URL.replace('##ideaId##', ideaId)
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.method = 'POST'
  apiCall.auth = true
  return apiCall.getAction()
}

// get user Idea
export function getInnovateUserIdeas(email) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = userProfileActions.GET_INNOVATE_USER_IDEAS_STARTED
  apiCall.successReqType = userProfileActions.GET_INNOVATE_USER_IDEAS_SUCCESS
  apiCall.failureReqType = userProfileActions.GET_INNOVATE_USER_IDEAS_FAILURE
  apiCall.setEndpointFromState = () => `${GET_USER_IDEAS_URL.replace('##email##', email)}`
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}



// Get challenge tagged idea list with evaluators 
export function getInnovateChallengeTaggedIdeaList(ChallengeKey) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED
  apiCall.successReqType = INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS
  apiCall.failureReqType = INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE
  apiCall.setEndpointFromState = () => Innovate_CHALLENGE_TAGGED_IDEA_LIST_URL.replace('##challengeKey##', ChallengeKey)
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformIdeaTeamResponse
  return apiCall.getAction()
}

//post bulk idea sme

export function postInnovateIdeaAddBySMEGroups(AddBulkEvaluatParams,onFailure,onSuccess){
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED
  apiCall.successReqType = ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS
  apiCall.failureReqType = ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE
  apiCall.setEndpointFromState = () => ADD_BULK_SME_AUTO_ASSIGN_EVALUATOR_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = () => setContentAddBulkSME(AddBulkEvaluatParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

//get evalution dash board innovate idea email
export const getMyEvaluationDashboardIdeaHistory= (userEmail) => {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED
  apiCall.successReqType = GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS
  apiCall.failureReqType = GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE
  apiCall.setEndpointFromState = () => GET_INNOVATE_IDEA_HISTORY_EMAIL_URL.replace('##email##',userEmail)
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}